import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Home from './pages/Home';
import PropertyDetails from './pages/PropertyDetails';
import "../src/index.css";
import { HouseContextProvider } from './components/HouseContext';
import Lenis from 'lenis';
import PageTransition from './components/PageTransition';
import HouseList from './pages/HouseList';
import ServicesPage from './pages/Services_Page';
import Contact from './pages/Contact';


function App() {
  const location = useLocation();
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };


  useEffect(() => {
    const lenis = new Lenis();
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => {
      lenis.destroy();
    };
  }, []);
  
  return (
    <HouseContextProvider>
      <div className="max-w-[1440px] mx-auto bg-body position relative">
        <AnimatePresence mode='wait'>
          {/* Routes keyed by pathname so every page gets the same enter/exit transition */}
            <Routes location={location} key={location.pathname}>
              <Route path='/' element={<PageTransition><Home toggleMobileMenu={toggleMobileMenu} /></PageTransition>} />
              <Route path="/house-list" element={<PageTransition><HouseList toggleMobileMenu={toggleMobileMenu} /></PageTransition>} />
              <Route path='/services_page/:serviceType' element={<PageTransition><ServicesPage toggleMobileMenu={toggleMobileMenu} /></PageTransition>} />
              <Route path='/property/:id/*' element={<PageTransition><PropertyDetails toggleMobileMenu={toggleMobileMenu} /></PageTransition>} />
              <Route path='/contact' exact element={<PageTransition><Contact toggleMobileMenu={toggleMobileMenu} /></PageTransition>} />
            </Routes>
        </AnimatePresence>
      </div>
    </HouseContextProvider>
  );
}

export default App;
